import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';
import type ThoughtBubbleFlowModel from './thought-bubble-flow';

export default class ThoughtBubbleFlowInvocationModel extends Model {
  @attr declare flowId: string;
  @attr declare personId: string;
  @attr declare stepsCompleted: Record<string, unknown>;
  @attr declare completed: boolean;
  @attr declare browserMeta: Record<string, string>;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;

  @belongsTo('thought-bubble-flow', { async: false, inverse: null })
  declare flow: ThoughtBubbleFlowModel;

  [Type] = 'thought-bubble-flow-invocation' as const;
}
